import {
  format_list_bulleted as formatListBulleted,
  grid_on as gridOn,
  timeline,
} from '@equinor/eds-icons';
import { VariogramIcon } from '../../../assets/VaritogramIcon';
import { useFetchModelScenarios } from '../../../hooks/useFetchModelScenarios';
import type { SidebarLink } from '../types';

export const useModelLinks = (modelId: string | undefined): SidebarLink[] => {
  const { data: scenarios } = useFetchModelScenarios(modelId);
  const hasSimulation = !!scenarios && scenarios.length > 0;
  const hasTemplate = scenarios?.some((s) => s.scenario_template_id) ?? false;

  return [
    {
      title: 'Details',
      path: `/models/${modelId}`,
      icon: formatListBulleted,
    },
    ...(hasSimulation
      ? [
          {
            title: 'Simulation',
            path: `/models/${modelId}/simulation`,
            icon: timeline,
            nonCollapsible: true,
            children: [
              {
                title: 'Results',
                path: `/models/${modelId}/simulation/results`,
              },
              ...(hasTemplate
                ? [
                    {
                      title: 'Parameters',
                      path: `/models/${modelId}/simulation/parameters`,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    {
      title: 'Object',
      path: `/models/${modelId}/compute/object`,
      icon: gridOn,
      nonCollapsible: true,
      children: [
        {
          title: 'Compute settings',
          path: `/models/${modelId}/compute/object`,
        },
        {
          title: 'Results',
          path: `/models/${modelId}/results/object`,
        },
      ],
    },
    {
      title: 'Variogram',
      path: `/models/${modelId}/compute/variogram`,
      icon: VariogramIcon,
      nonCollapsible: true,
      children: [
        {
          title: 'Compute settings',
          path: `/models/${modelId}/compute/variogram`,
        },
        {
          title: 'Results',
          path: `/models/${modelId}/results/variogram`,
        },
      ],
    },
  ];
};
